import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Command } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Commands/PathItems';

export interface CommandOption {
  id: number;
  name: string;
}

interface LinkCommandDialogProps {
  open: boolean;
  availableCommands: Command[];
  onClose: () => void;
  onSelect: (command: Command) => void;
}

const LinkCommandDialog: React.FC<LinkCommandDialogProps> = ({ open, availableCommands, onClose, onSelect }) => {
  const [selectedId, setSelectedId] = useState<string | ''>('');

  useEffect(() => {
    setSelectedId('');
  }, [open]);

  const handleOk = () => {
    const cmd = availableCommands.find(c => c.id === selectedId);
    if (cmd) onSelect(cmd);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Link Command</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="command-select-label">Command</InputLabel>
          <Select
            labelId="command-select-label"
            value={selectedId}
            label="Command"
            onChange={e => setSelectedId(e.target.value)}
          >
            {availableCommands.map(cmd => (
              <MenuItem key={cmd.id} value={cmd.id}>{cmd.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleOk} disabled={selectedId === ''} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkCommandDialog;
